interface OrderIconProps {
  isActive?: boolean;
}

export const OrderIcon: React.FC<OrderIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0148 8.612C19.9796 7.36458 19.8616 6.56913 19.462 5.89071C18.893 4.92494 17.8691 4.38734 15.8225 3.31405L13.9195 2.31497C12.2486 1.43864 11.4132 1 10.515 1C9.61678 1 8.78137 1.43769 7.11053 2.31497L5.20753 3.31405C3.16086 4.38734 2.13704 4.92494 1.56805 5.89071C1 6.85553 1 8.05728 1 10.4579V10.5692C1 12.9718 1 14.1735 1.56805 15.1383C2.13704 16.1041 3.16086 16.6417 5.20753 17.716L7.11053 18.7141C8.78137 19.5914 9.61678 20.03 10.515 20.03C11.4132 20.03 12.2486 19.5923 13.9195 18.715L15.8225 17.716C17.8691 16.6417 18.893 16.1051 19.462 15.1393C19.8616 14.4609 19.9796 13.6654 20.0148 12.418M19.0785 6.23325L15.2725 8.13625M15.2725 8.13625L14.7967 8.37413L10.515 10.515M15.2725 8.13625V11.4665M15.2725 8.13625L6.23325 3.37875M10.515 10.515L1.9515 6.23325M10.515 10.515V19.5543"
        stroke={isActive ? "var(--active-color)" : "#83829D"}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
};
